import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import { Typography, Box, ButtonGroup, Button } from "@mui/material";

const OrdersChart = () => {
  const [timeRange, setTimeRange] = useState("monthly");

  // Sample data - replace with actual data from your API
  const monthlyData = {
    series: [
      {
        name: "Orders",
        data: [76, 85, 101, 98, 87, 105, 91, 114, 94, 86, 115, 92],
      },
    ],
    categories: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
  };

  const weeklyData = {
    series: [
      {
        name: "Orders",
        data: [21, 35, 28, 32, 45, 47, 25],
      },
    ],
    categories: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
  };

  const data = timeRange === "monthly" ? monthlyData : weeklyData;

  const options = {
    chart: {
      type: "bar",
      height: 300,
      toolbar: {
        show: false,
      },
      fontFamily: "Outfit, sans-serif",
    },
    plotOptions: {
      bar: {
        borderRadius: 4,
        columnWidth: "55%",
        distributed: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories: data.categories,
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "11px",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 400,
        },
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: "#6B7280",
          fontSize: "11px",
          fontFamily: "Outfit, sans-serif",
          fontWeight: 400,
        },
      },
    },
    grid: {
      borderColor: "#F3F4F6",
      strokeDashArray: 4,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    colors: ["#4A47A3"],
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " orders";
        },
      },
      style: {
        fontSize: "12px",
        fontFamily: "Outfit, sans-serif",
      },
    },
  };

  return (
    <Box className="p-5">
      <Box className="flex justify-between items-center mb-4">
        <Typography variant="subtitle1" className="font-medium text-[#374151]">
          Order Trends
        </Typography>
        <ButtonGroup
          variant="outlined"
          size="small"
          sx={{
            ".MuiButtonGroup-grouped": {
              borderColor: "rgba(86, 82, 176, 0.15)",
            },
          }}>
          <Button
            onClick={() => setTimeRange("weekly")}
            sx={{
              fontSize: "0.7rem",
              textTransform: "none",
              padding: "3px 8px",
              minWidth: "60px",
              color: timeRange === "weekly" ? "white" : "#5652B0",
              backgroundColor:
                timeRange === "weekly" ? "#5652B0" : "transparent",
              borderColor: "rgba(86, 82, 176, 0.15)",
              "&:hover": {
                backgroundColor:
                  timeRange === "weekly"
                    ? "#4A47A3"
                    : "rgba(86, 82, 176, 0.05)",
                borderColor: "rgba(86, 82, 176, 0.2)",
              },
            }}>
            Weekly
          </Button>
          <Button
            onClick={() => setTimeRange("monthly")}
            sx={{
              fontSize: "0.7rem",
              textTransform: "none",
              padding: "3px 8px",
              minWidth: "60px",
              color: timeRange === "monthly" ? "white" : "#5652B0",
              backgroundColor:
                timeRange === "monthly" ? "#5652B0" : "transparent",
              borderColor: "rgba(86, 82, 176, 0.15)",
              "&:hover": {
                backgroundColor:
                  timeRange === "monthly"
                    ? "#4A47A3"
                    : "rgba(86, 82, 176, 0.05)",
                borderColor: "rgba(86, 82, 176, 0.2)",
              },
            }}>
            Monthly
          </Button>
        </ButtonGroup>
      </Box>
      <Box sx={{ height: 270 }}>
        <ReactApexChart
          options={options}
          series={data.series}
          type="bar"
          height="100%"
        />
      </Box>
    </Box>
  );
};

export default OrdersChart;
